const urlExport = [
	'/current-user/codes/export',
	'/current-user/salesorders/byItem/export',
	'/current-user/consignment/export',
	'/current-user/payments-collection/export',
	'/current-user/items/export',
	'/current-user/salesorders/export', //5
	'/current-user/stocks/summary/export',
	'/current-user/prices-manager/item/export',
	'/current-user/prices-manager/kiosk/export',
	'/promotions/campaigns/export',
	'/current-user/price-update/campaigns/export', //10
	'/current-user/logs/users/export',
	'/current-user/logs/kiosks/export',
	'/current-user/logs/extranet/export',
	'/current-user/logs/synchro/export',
	'kiosk-request/business/export', //15
	'kiosk-request/customer/export',
	'/marketing/export',
	'/kiosks-production/export',
	'/kiosks-production/{0}/logs/export',
	'/current-user/salesorders/merchant-ticket/export', // 20 btn merchant ticket
	'/kiosks-transaction/analysis/export',
]

export default urlExport
